<template>
  <page-outline :title="$t('Webheader.company')">
    <template slot="pageContent">
      <!-- <div class="layoutTop"></div> -->
      <div class="overflow-hidden">
        <b-row class="no-gutters">
          <b-col md="12">
            <div class="requestsList">
              <div class="mt-0">
                <spinner v-if="activateSpinner"></spinner>
                <div v-else class="overflow-x-unset">
                  <f7-list class="mb-2">
                    <f7-list-item :class="additionalClass">
                      <div class="d-flex">
                        <!-- Left section filtre -->
                        <div>
                          <b-button class="btn btnFilter"
                            @click="displayFilter = !displayFilter">
                            <i v-if="displayFilter" class="fa-light fa-minus"></i>
                            <i v-else class="fa-light fa-plus"></i>
                          </b-button>
                        </div>
                        <div class="mx-3">
                          <b-button class="btn btnFilter"
                            @click="refreshInbox()">
                            <i class="fa-light fa-rotate-right"></i>
                          </b-button>
                        </div>
                        <!-- Right section filtre -->
                        <div>
                          <b-button class="btn btnFilter_2"
                            @click="exportCompany()">
                            <i class="fa-light fa-upload"></i>
                            <span class="fab-label">{{ $t('common.extract_list') }}</span>
                          </b-button>
                        </div>

                        <div cols="4" offset="8" class="d-flex flex-row-reverse mt-5px" v-if="displayFilter">
                        </div>
                      </div>
                    </f7-list-item>

                    <!-- Sélection des valeurs de Filtre -->
                    <f7-list-item :class="{'filter-item-section':true, 'd-none': !displayFilter}">
                      <b-row class="min-w-100">
                        <!-- <b-col class="d-flex flex-row"> -->
                        <!--Filtre active -->
                        <b-col lg="3" cols="6" class="filter-item mb-3">
                          <span class="filter-item-title">{{ $t('administration.active') }}</span>
                          <span class="filter-item-content">
                            <select ref="selectDoctype"
                              v-model="active" class="pt-1 z-2 h-auto cursor fs-14px-important">
                              <option value="">{{ $t('administration.select_activity') }}</option>
                              <option value="0"> {{ $t('administration.no') }} </option>
                              <option value="1"> {{ $t('administration.in_prgrss') }} </option>
                              <option value="2"> {{ $t('administration.yes') }} </option>
                            </select>
                            <i class="fa-light fa-chevron-down p-1 z-1 float-right cursor mt--22px-important" id="status-chevron">
                            </i>
                          </span>
                        </b-col>
                        <!-- Filtre identifiant -->
                        <b-col lg="3" cols="6" class="filter-item mb-3">
                          <span class="filter-item-title">{{ $t('administration.user_login') }}</span>
                          <span class="filter-item-content">
                            <input v-model="identifier"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': identifier}"
                              :placeholder="$t('administration.enter_id')">
                            </input>
                          </span>
                        </b-col>
                        <!-- Filtre name -->
                        <b-col lg="3" cols="6" class="filter-item">
                          <span class="filter-item-title">{{ $t('administration.user') }}</span>
                          <span class="filter-item-content">
                            <input v-model="name"
                              type="text"
                              :class="{'filter-item-input': true, 'filter-item-input-complete': name}"
                              :placeholder="$t('administration.enter_company_name')">
                            </input>
                          </span>
                        </b-col>
                        <!-- Bouton Effacer et Appliquer -->
                        <b-col lg="3" cols="12" class="d-flex flex-row-reverse mt-3">
                          <b-button class="btn" size="sm"
                            @click="applyFilter()">
                            {{ $t('filter.fltr') }}
                          </b-button>
                          <b-button class="btn mr-3" size="sm"
                            @click="clearFilterFields"
                            :disabled="!hasInputFilter">
                            {{ $t('filter.clr_fltr_field') }}
                          </b-button>
                        </b-col>
                      </b-row>
                    </f7-list-item>
                  </f7-list>
                  <b-table v-if="CompaniesList.length" hover
                  class="mt-3"
                  :items="CompaniesList"
                  :fields="companyFields"
                  :selectable="CompaniesList.length > 0"
                  empty-text="Pas de résultat"
                  @row-selected="seeCompanyDetails">
                    <template #cell(active)="data">
                      <div v-if="data.value === '0'"><i class="fa-duotone fa-xmark btn btn-icon btn-icon-red"></i></div>
                      <div v-else-if="data.value === '1'"><i class="fa-duotone fa-warning btn btn-icon btn-icon-orange"></i></div>
                      <div v-else-if="data.value === '2'"><i class="fa-duotone fa-check btn btn-icon btn-icon-green"></i></div>
                    </template>
                    <template #cell(edit)="data">
                      <span class="text-center d-inline-block py-4 w-100" @click="activateEdit($event, data.value)"><i class="fa-regular fa-pencil"></i></span>
                    </template>
                    <template #cell(delete)="data">
                      <span class="text-center d-inline-block py-4 w-100" @click="activateDelete($event, data.value)"><i class="fa-light fa-trash"></i></span>
                      <span></span>
                    </template>
                  </b-table>
                  <!-- ANCIENNE TABLE DRO 16/08/2023
                  <table class="table mt-3 text-center" v-if="CompaniesList.length">
                    <thead>
                      <tr>
                        <th class="text-center">
                          {{ $t('administration.active_enable') }}
                        </th>
                        <th class="text-center">
                          {{ $t('common.idtfr') }}
                        </th>
                        <th class="text-center">
                          {{ $t('common.user') }}
                        </th>
                        <th class="text-center">
                          {{ $t('common.eml_adrs') }}
                        </th>
                        <th v-if="canUserEditCompagny" class="text-center">
                          {{ $t('rights.edit') }}
                        </th>
                        <th v-if="canUserDeleteCompagny" class="text-center">
                          {{ $t('common.del_label') }}
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="result in CompaniesList" :key="result.index" class="boxRequest line-hover">
                        <td class="text-center" @click="activateDetail(result.id_account)">
                          <div v-if="result.active ==='0'"><i class="fa-duotone fa-xmark btn btn-icon btn-icon-red"></i></div>
                          <div v-else-if="result.active === '1'"><i class="fa-duotone fa-warning btn btn-icon btn-icon-orange"></i></div>
                          <div v-else-if="result.active === '2'"><i class="fa-duotone fa-check btn btn-icon btn-icon-green"></i></div>
                        </td>
                        <td class="text-center" @click="activateDetail(result.id_account)">{{ result.identifier }}</td>
                        <td class="text-center" @click="activateDetail(result.id_account)">{{ result.name }}</td>
                        <td class="text-center" @click="activateDetail(result.id_account)">{{ result.email_reference }}</td>
                        <td v-if="canUserEditCompagny" @click="activateEdit(result.id_account)"><i class="fa-light fa-pencil cursor"></i></td>
                        <td v-if="canUserDeleteCompagny" @click="activateDelete(result.id_account)"><i class="fa-light fa-trash"></i></td>
                      </tr>
                    </tbody>
                  </table>-->

                  <div v-else class="d-flex justify-content-center">
                    <span class="noResult">
                      {{ $t('common.no_result') }}
                    </span>
                  </div>

                  <b-row class="justify-content-end mt-3 no-gutters">
                    <b-button class="mt-3" v-if="canUserAddCompagny"
                    @click="addCompany" variant="primary">
                      <i class="fa-light fa-plus fs-17px"></i>
                      <span>{{$t('administration.company_add')}}</span>
                    </b-button>
                  </b-row>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>

<script>
import moment from 'moment'
import Pagination from '@/components/common/pagination.vue'
import Spinner from '@/components/common/spinner.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import PageOutline from '@/components/common/PageOutline.vue'
import { downloadFileWithDefinedHeaders } from '@/helpers/download'


export default {
  name: 'Companies',
  components: {
    'cm-pagination': Pagination,
    'spinner': Spinner,
    'page-outline': PageOutline
  },
  props: {
    additionalClass: {
      type: String,
      default: ''
    },
    direction: {
      default: '2',
      type: String
    }
  },
  computed: {
    buttonsListStyle () {
      return (!this.isSmartphoneOS) ? 'border: 1px solid #aaa;' : ''
    },
    companyFields() {
      let fields = [
        { key: 'identifier', label: this.$t('common.idtfr'), class:'text-center', sortable: true },
        { key: 'name', label: this.$t('common.user'), class:'text-center', sortable: true },
        { key: 'email_reference', label: this.$t('common.eml_adrs'), class:'text-center', sortable: true },
      ]
      if(this.canUserEditCompagny) {
      fields.push({ key: 'edit', label: this.$t('rights.edit'), thClass: 'text-center', tdClass: 'p-0'})
      }
      if(this.canUserDeleteCompagny) {
        fields.push({ key: 'delete', label: this.$t('common.del_label'), thClass: 'text-center', tdClass: 'p-0'})
      }
      return fields
    },
    isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
    emailReferenceDirection () {
      return ((this.sortField === 'email_reference' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    activeDirection () {
      return ((this.sortField === 'active' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    identifierDirection () {
      return ((this.sortField === 'identifier' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    nameDirection () {
      return ((this.sortField === 'name' && this.sortDirection === 'ASC') ? 'fa-caret-up' : 'fa-caret-down')
    },
    listTitle () {
      return this.$t('Webheader.company')
    },
    hasInputFilter () {
      if (
        this.active ||
        this.identifier ||
        this.name) {
        return true
      }
      return false
    },
    canUserAddCompagny() {
      return this.$engine.rights.rightIs('company_ajouter', true) || this.$engine.rights.rightIs('company_ajouter_admin', true)
    },
    canUserEditCompagny () {
      return this.$engine.rights.rightIs('company_editer', true) || this.$engine.rights.rightIs('company_editer_admin', true)
    },
    canUserDeleteCompagny () {
      return this.$engine.rights.rightIs('company_supprimer', true) || this.$engine.rights.rightIs('company_supprimer_admin', true)
    }
  },
  data () {
    return {
      activateSpinner: false,
      active: '',
      identifier: '',
      filterBy: '',
      name: '',
      CompaniesList: [],
      idCompany: '',
      mode: 1,
      noMore: false,
      pageCounter: 0,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      requestsNumber: '',
      scrollFlag: true,
      sortDirection: 'DESC',
      sortField: 'dateAction',
      displayFilter: false,
      hasDefaultFilter: false,
    }
  },
  created () {
    this.$bus.$emit('change-mobile-header', {
      backLink: false,
      navbarInnerStyle: 'justify-content:start;',
      navTitle: 'Entreprise',
      returnUrl: ''
    })
    this.paginationObject['firstIndex'] = 1
    this.paginationObject['maxResults'] = 13
    this.paginationObject['nbResultsTotal'] = 0
    let that = this
    this.$engine.settings.set({msgDirection: this.direction})
    this.$bus.$off('refresh-cache-contacts')

    this.paginationObject['refresh'] = 'direct-inbox-filtered'
    this.$bus.$off('direct-inbox-filtered')
    this.$bus.$on('direct-inbox-filtered', index => {
      this.onRefresh(false, index)
      that.pageCounter = 0
    })
    this.$f7.initPullToRefresh()
    this.pageCounter = 0
    this.onRefresh(false)
    this.filterTypeGet = this.filterType
    this.$bus.emit('right-panel-set-feature', 'filter-messages')
  },
  mounted () {
    this.$$('.infinite-scroll-preloader').remove()
    let defaultFilter = this.$engine.company.getDefaultFilter()
    this.setDefaultFilter(defaultFilter)
  },
  beforeDestroy () {
    let that = this
    that.$engine.company.cleanFilterCondition()
  },
  methods: {
    applyFilter (filterConditions = {}) {
      let that = this
      let defaultFilter = this.$engine.company.getDefaultFilter()
      this.filterTypeGet = 'list'
      this.setDefaultFilter(defaultFilter)
      this.$engine.company.cleanFilterCondition()
      this.$engine.company.active = this.active
      this.$engine.company.identifier = this.identifier
      this.$engine.company.name = this.name

      for (let propertyCustom in filterConditions) {
        this.$engine.company[propertyCustom] = filterConditions[propertyCustom]
      }
      filterConditions = this.$engine.company.getConditionObject()
      // this.$emit('applyFilter', actualFilter.getConditionObject())

      this.pageCounter = 0
      this.paginationObject['firstIndex'] = 1
      this.paginationObject['nbResultsTotal'] = 0

      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.activateSpinner = true
      this.$engine.company.getCompanies(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResults = resp.data.companies.length
        resp.data.companies.forEach(item => {
          item.email_reference = item.account.email_reference
          item.active = item.account.active
          item.identifier = item.account.identifier
          item.name = item.account.name
          item.id_account = item.account.id_account
        })
        requests = resp.data.companies
        that.updateInbox(requests)
        // this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    toggleRightPanel () {
      this.$bus.emit('right-panel-toggle')
    },
    communicateChange () {
      this.$bus.emit('right-panel-filter-view-update-fields', this.filterFields)
    },
    clearFilterFields () {
      this.active = ''
      this.identifier = ''
      this.name = ''
      this.communicateChange()
      this.applyFilter()
    },
    deleteFilter () {
      this.$engine.company.saveDefaultFilter({})
      this.hasDefaultFilter = false
      this.$f7.modal({
        title: 'Filtre supprimé',
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    saveDefaultFilter () {
      let that = this

      let defaultFilter = {
        active: this.active,
        identifier: this.identifier,
        name: this.name
      }

      this.$engine.company.saveDefaultFilter(defaultFilter)

      if (this.hasInputFilter) {
        this.hasDefaultFilter = true
      }

      that.$f7.modal({
        title: this.$i18n.t('filter.dflt_fltr_svd'),
        buttons: [
          {
            text: 'OK',
            onClick: function () {
              return
            }
          }
        ]
      })
    },
    seeCompanyDetails (items) {
      this.activateDetail(items[0].id_account)
    },
    setDefaultFilter (defaultFilter) {
      for (const property in defaultFilter) {
        this[property] = defaultFilter[property]
        if (defaultFilter[property]) {
          this.hasDefaultFilter = true
        }
      }
    },
    attachInfinit () {
      if (this.$settings.inboxPreloaderRemoved ||
          this.$settings.sendboxPreloaderRemoved) {
        // this.$$('.infinite-scroll').append(
        // '<div class="infinite-scroll-preloader"><div class="preloader"></div></div>'
        // )
        this.$f7.attachInfiniteScroll(this.$$('.infinite-scroll'))
        this.$engine.settings.set({inboxPreloaderRemoved: false})
      }
      this.scrollFlag = true
      this.noMore = false
    },
    detachInfinit () {
      this.$$('.infinite-scroll-preloader').remove()
      this.$f7.detachInfiniteScroll(this.$$('.infinite-scroll'))
      this.$engine.settings.set({inboxPreloaderRemoved: true})
      if (!this.emptyBox) {
        this.scrollFlag = false
        this.noMore = true
      }
    },
    exportCompany () {
      this.$f7.showPreloader(this.$i18n.t('common.loading_page_label'))
      let firstLine = 'Adresse email' + ';' +
        'Active' + ';' +
        'Nom' + ';' +
        'Identifiant' + ';' + '\r\n'
      let lines = ''
      for (var i = 0; i < this.CompaniesList.length; i++) {
        let result = this.CompaniesList[i]
        let iconActive
        if (result.active === "0") {
          iconActive = this.$t('administration.no')
        } else if (result.active === "1") {
          iconActive = this.$t('administration.in_prgrss')
        } else if (result.active === "2") {
          iconActive = this.$t('administration.yes')
        }
        lines += result.email_reference + ';' +
                 iconActive + ';' +
                 result.name + ';' +
                 result.identifier + ';' + '\r\n'
      }
      let data = firstLine + lines
      this.$f7.hidePreloader()
      let linkSource = 'data:text/csv;charset:utf-8;base64,' + btoa(data)
      let downloadLink = document.createElement('a')
      let today = moment()
      let fileName = 'company_' + today.unix() + '.csv'
      if (
      this.$f7.device.os === 'android' ||
      this.$f7.device.os === 'ios'
      ) {
        downloadFileWithDefinedHeaders(this, fileName, linkSource)
      } else {
        downloadLink.href = linkSource
        downloadLink.download = fileName
        downloadLink.click()
      }
      this.$f7.alert('', this.$i18n.t('common.exprt_succ'))
    },
    onClear () {
      this.filterBy = ''
      this.attachInfinit()
    },
    onDisable () {
      this.attachInfinit()
    },
    onEnable () {
      this.detachInfinit()
    },
    onInfinite () {
      if (this) {
        return
      }
      if (this.scrollFlag) {
        this.scrollFlag = false
        let that = this
        this.pageCounter = this.pageCounter + 1
        this.paginationObject['firstIndex'] = this.pageCounter * this.paginationObject['maxResults'] + 1
        this.paginationObject['nbResultsTotal'] = 0

        let filterConditions
        if (this.$engine.company.getDefaultFilter()) {
          filterConditions = this.$engine.company.getDefaultFilter()
        } else {
          filterConditions = this.$engine.company.getConditionObject()
        }
        filterConditions.sortField = 'SF' + this.sortField
        filterConditions.sortDirection = this.sortDirection
        this.$engine.company.getCompanies(
          this.paginationObject['maxResults'],
          this.paginationObject['firstIndex'],
          filterConditions
        ).then(resp => {
          let requests = {}
          that.requestsNumber = resp.data.companies.length
          resp.data.companies.forEach(item => {
            item.email_reference = item.account.email_reference
            item.active = item.account.active
            item.identifier = item.account.identifier
            item.name = item.account.name
            item.id_account = item.account.id_account
          })
          requests = resp.data.companies
          that.paginationObject.nbResults = that.requestsNumber

          if (requests.length > 0) {
            for (let i = 0; i < requests.length; i++) {
              that.CompaniesList.push(requests[i])
            }
            if (requests.length < this.paginationObject['maxResults']) {
              that.detachInfinit()
            }
          } else {
            that.detachInfinit()
          }
          that.scrollFlag = true
        })
        .catch(error => {
          errorMessageAlert(error, that, that.$i18n)
          that.scrollFlag = true
        })
      }
    },
    onRefresh (noAttach = false, index = 1) {
      let that = this
      this.pageCounter = 0
      // this.scrollFlag = true
      this.paginationObject['firstIndex'] = index
      this.paginationObject['nbResultsTotal'] = 0

      this.activateSpinner = true
      let filterConditions
      if (this.$engine.company.getDefaultFilter()) {
        filterConditions = this.$engine.company.getDefaultFilter()
      } else {
        filterConditions = this.$engine.company.getConditionObject()
      }
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.$engine.company.getCompanies(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResults = resp.data.companies.length
        resp.data.companies.forEach(item => {
          item.email_reference = item.account.email_reference
          item.active = item.account.active
          item.identifier = item.account.identifier
          item.name = item.account.name
          item.id_account = item.account.id_account
          item.edit = item.account.id_account
          item.delete = item.account.id_account
          // item.typeAction = this.$t('company.' + item.typeAction)
        })
        requests = resp.data.companies
        that.updateInbox(requests, noAttach)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    onSearch (query, found) {
      this.filterBy = query
    },
    /* activateDetail (ressource) {
      console.log('ressource:', ressource)
      this.$bus.emit('id_account-info', ressource)
      this.$f7.popup('#show-detail-true')
      this.$bus.off('id_account-info', ressource)
    }, */
    activateDetail (ressource) {
      // let that = this
      // console.log('id account', ressource)
      // this.idCompany = ressource
      /* this.$bus.$emit('call_company_details', ressource)
      setTimeout(function () {
        reloadPage2(that, '/detail/')
      }, 1000) */
      let that = this
      loadPage(that, {url: '/detail/' + ressource})
    },
    activateEdit ($e, ressource) {
      let that = this
      $e.stopPropagation() //AJOUTER EN PARAMETRE "$e"
      loadPage(that, {url: '/editcompany/' + ressource})
    },
    refreshInbox () {
      this.onRefresh()
    },
    activateDelete ($e, ressource) {
      let that = this
      $e.stopPropagation()
      if (ressource === this.$engine.user.get().id) {
        that.$f7.modal({
          title: this.$i18n.t('administration.del_company_impbl'),
          buttons: [
            {
              text: 'OK',
              onClick: function () {
                return
              }
            }
          ]
        })
      } else {
        this.$f7.modal({
          title: this.$i18n.t('administration.del_company_qt'),
          buttons: [
            {
              text: this.$t('creation_forms.vldt'),
              onClick: function () {
                that.$engine.company.deleteCompany(ressource)
                .then(resp => {
                  that.$f7.alert('', that.$t('administration.del_company'))
                  that.onRefresh(false)
                })
              }
            },
            {
              text: this.$t('common.cncl'),
              onClick: function () {
                return
              }
            }
          ]
        })
      }
    },
    addCompany () {
      let that = this
      loadPage(that, {url: '/addcompany/'})
    },
    reOrderBy (column) {
      let that = this
      if (this.sortField === column) {
        // just switch order
        this.sortDirection = this.sortDirection === 'ASC' ? 'DESC' : 'ASC'
      } else {
        // new column + default order
        this.sortField = column
        switch (column) {
          case 'dateAction':
            this.sortDirection = 'DESC'
        }
      }
      let filterConditions
      if (this.$engine.company.getDefaultFilter()) {
        filterConditions = this.$engine.company.getDefaultFilter()
      } else {
        filterConditions = this.$engine.company.getConditionObject()
      }
      filterConditions.sortField = 'SF' + this.sortField
      filterConditions.sortDirection = this.sortDirection
      this.$engine.company.getCompanies(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        that.paginationObject.nbResults = resp.data.companies.length
        resp.data.companies.forEach(item => {
          item.email_reference = item.account.email_reference
          item.active = item.account.active
          item.identifier = item.account.identifier
          item.name = item.account.name
          item.id_account = item.account.id_account
        })
        requests = resp.data.companies
        that.updateInbox(requests, false)
        that.$f7.pullToRefreshDone()
        that.$bus.emit('refresh-cache-paging-template', that.paginationObject)
        that.activateSpinner = false
      })
      .catch(error => {
        that.activateSpinner = false
        errorMessageAlert(error, that)
      })
    },
    updateInbox (requests, noAttach = false) {
      this.CompaniesList = requests
      if (requests.length === this.paginationObject['maxResults']) {
        if (!noAttach) {
          this.attachInfinit()
        }
      } else {
        this.detachInfinit()
      }
    },
    showButtonImportLot () {
      // Service RTP import lot identifiant?
      return false
    }
  }
}
</script>
